import * as angular from 'angular';

export class ViewportController {

    viewport = {
        width: $(window).width(),
        height: $(window).height(),
        scrollTop: 0
    };

    constructor(
        public scope: { $apply: () => void }
    ) {
        $(window).resize(() => {
            this.viewport.width = $(window).width();
            this.viewport.height = $(window).height();
            scope.$apply();
        });

        $(window).scroll(() => {
            this.viewport.scrollTop = $(document).scrollTop();
            scope.$apply();
        });
    }
}

angular.module('app.common').controller('ViewportController', ViewportController);



// WEBPACK FOOTER //
// ./src/app.common/modules/common/controllers/viewport-typed.controller.ts